import React, { useState, useEffect } from "react";
import { Form, Typography, Input, Space, Button, Select, Switch } from "antd";

import { SaveOutlined, UndoOutlined } from "@ant-design/icons";

//Importaciones para el uso de Redux
import { useDispatch } from "react-redux";
import { updateRolEnviromentAction } from "../../../actions/rolEnviromentActions";

//Styles
import curStyle from "../../../css/GlobalCmp.module.css";

//Importaciones Propias
import CST from "../../../utils/CustomSettings";
import { showNotification } from "../../../utils/ShowNotification";
import FRM from "../../../utils/FrmService";

export default function TiposAlimentoForm(props) {
  const { record, medidas, closeModal, currentUser, varEffec } = props;
  const [form] = Form.useForm();
  const [curId, setCurId] = useState(record.id);
  const [loadingButton, setLoadingButton] = useState(false);

  useEffect(() => {
    setCurId(record.id);
  }, [varEffec]);

  //Ejecutar dispatch tras el logueo
  const dispatch = useDispatch();
  const updateEnviroment = (state) =>
    dispatch(updateRolEnviromentAction(state));

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  };

  const { Title } = Typography;

  const { Option } = Select;

  const guardarCambios = async (values) => {
    console.log(values);
    setLoadingButton(true);
    let val_record = await FRM.sendMaestro(
      currentUser,
      curId,
      "TipoAlimento",
      values
    );
    if (val_record.type && Number.parseInt(val_record.type) > 0) {
      updateEnviroment(val_record.datos.rol_entorno);
      showNotification(
        "topRight",
        4,
        "GESTION DE TIPOS DE ALIMENTO",
        "REGISTRO EXITOSO"
      );
    } else {
      showNotification(
        "topRight",
        2,
        "GESTION DE TIPOS DE ALIMENTO",
        val_record.message
      );
    }
    setLoadingButton(false);
    closeModal();
  };

  //Renderizacion del componente
  return (
    <Form
      {...layout}
      form={form}
      name="tiposalimento"
      onFinish={guardarCambios}
      initialValues={{
        alm_nombre: record.id > 0 ? record.alm_nombre : "",
        alm_factor: record.id > 0 ? record.alm_factor : 0,
        alm_kilos: record.id > 0 ? record.alm_kilos : 1,
        mdd_id: record.id > 0 ? record.mdd_id : 1,
      }}
      scrollToFirstError
    >
      <Form.Item>
        <Title
          level={4}
          style={{
            padding: 2,
            margin: 2,
            fontWeight: 600,
            textAlign: "left",
            color: CST.colorSec,
          }}
        >
          {record.id > 0
            ? "ACTUALIZAR TIPO DE ALIMENTO"
            : "AGREGAR TIPO DE ALIMENTO"}
        </Title>
      </Form.Item>
      <Form.Item
        name="alm_nombre"
        label="Nombre"
        rules={[
          {
            required: true,
            message: "El nombre es obligatorio",
          },
        ]}
      >
        <Input
          style={{ textTransform: "uppercase" }}
          value={record.id > 0 ? record.alm_nombre : ""}
        />
      </Form.Item>
      <Form.Item
        name="mdd_id"
        label="Unidad"
        rules={[
          {
            required: true,
            message: "La unidad es obligatoria",
          },
        ]}
      >
        <Select
          showSearch
          showArrow
          style={{ width: "40%" }}
          defaultValue={record.mdd_id}
          placeholder="Unidad"
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {medidas.map((medida) => (
            <Option key={medida.mdd_id} value={medida.mdd_id}>
              {medida.mdd_codigo}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        name="alm_factor"
        label="% Secado"
        rules={[
          {
            required: true,
            message: "El % es obligatorio",
          },
        ]}
      >
        <Input
          style={{ width: 100, textTransform: "uppercase" }}
          maxLength={8}
          value={record.id > 0 ? record.alm_factor : 0}
        />
      </Form.Item>
      <Form.Item
        name="alm_kilos"
        label="Kg x UND"
        rules={[
          {
            required: true,
            message: "Los Kilos son obligatorios",
          },
        ]}
      >
        <Input
          style={{ width: 100, textTransform: "uppercase" }}
          maxLength={8}
          value={record.id > 0 ? record.ctg_maximo : ""}
        />
      </Form.Item>
      <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 6 }}>
        <Space>
          <Button
            type="primary"
            htmlType="submit"
            className={curStyle.btnOrange}
            loading={loadingButton}
          >
            <SaveOutlined /> Guardar
          </Button>
          <Button
            type="primary"
            className={curStyle.btnInverse}
            onClick={() => closeModal()}
          >
            <UndoOutlined /> Cancelar
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
}
